export const TOGGLE_MAP_VIEW = 'TOGGLE_MAP_VIEW';
export const TOGGLE_AUDITORS = 'TOGGLE_AUDITORS';
export const TOGGLE_AUDITORS_FILTER = 'TOGGLE_AUDITORS_FILTER';
export const SET_INITIAL_AUDITORS_FILTER = 'SET_INITIAL_AUDITORS_FILTER';
